
import {
    Box,
    Typography,
    Container,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Animator from "../../components/Aminator/Animator";
import image from "../../assets/images/abouttHero.jpg"
import { useIsMobile } from "../hooks/useIsMobile";



export default function AboutHero() {
// Styled components (unchanged)
const HeroSection = styled(Box)(({ theme }) => ({
    position: "relative",
    backgroundColor: "#0A0E1A",
    color: "#fff",
    overflow: "hidden",
    minHeight: `${ isMobile? "80vh": "90vh"}`,
    marginTop: `${ isMobile ? "0px" : "132px"}`,
    display: "flex",
    alignItems: "center",
    padding: { xs: theme.spacing(4, 2), md: theme.spacing(4, 5)},
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat",
    "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
    },
}));

const ContentContainer = styled(Container)(({ theme }) => ({
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        alignItems: "center",
    },
}));

const TextContent = styled(Box)(({ theme }) => ({
    // paddingLeft: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
        width: "50%",
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(8),
    },
    [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(0),
    },
}));



  const isMobile = useIsMobile();
  const { t } = useTranslation();

  return (
    <HeroSection>
      <ContentContainer maxWidth="false">
        <TextContent>
          
          <Animator variant="slide" direction="right" timeout={800} delay={300} >
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "20px", md: "20px" },
                lineHeight: 1.2,
                color: "#EDE14F",
                fontFamily: "'Montserrat', sans-serif",
                mb: 3,
              }}
            >
              {t("about.hero.kicker")}

            </Typography>
          </Animator>

          <Animator variant="fade" timeout={800} delay={400}>
            <Typography
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                fontSize: { xs: "16px", md: "20px" },
                lineHeight: 1.6,
                maxWidth: "90%",
                fontFamily: "'Montserrat', sans-serif",
              }}
            >
              {t("about.hero.text")}
            </Typography>
          </Animator>          
        </TextContent>
      </ContentContainer>
    </HeroSection>
  );
}
